const getHighlightsOnlyIcon = (type, goals) => {
  if (type === 'Card_yellow') {
    return '<span class="pointer"></span><i class="icon-yellow-card"></i>';
  }
  if (type === 'Card_red' || type === 'Card_yellow_red') {
      return '<span class="pointer"></span><i class="icon-red-card"></i>';
  }
  if (['Goal', 'Penalty_successful', 'Goal_with_assist', 'Free_kick_hit'].includes(type)) {
      return '<span class="pointer"></span><i class="icon-ball-green"></i>';
  }
  return type;
}

function camelize(str) {
  return str.replace(/(?:^\w|[A-Z]|\b\w)/g, function(word, index) {
    return index === 0 ? word.toLowerCase() : word.toUpperCase();
  }).replace(/\s+/g, '');
}

export default ({ stats, highlights, data, homeTeamData, guestTeamData }) => (`
  <div class="card__body card__body--info" style="background-image:url(/assets/frontend/src/theme/images/spotlight-bgg.png)">
      <div class="match-info d-flex flex-column">
          <div class="match-info__score d-flex align-items-center justify-content-center">
              <div class="match-info__score-team d-flex flex-column"><div class="match-info__logo"><img class="match-info__logo-image" src="${homeTeamData?.team?.logo ? `/html/cornerkick/assets/images/match/teamlogo/${homeTeamData?.team?.logo}.png` : '/assets/images/logo2.svg'}" alt="" /></div> ${homeTeamData?.team?.name}</div>
              <div class="match-info__score-result text-center d-flex align-items-center justify-content-center">${stats?.Goals ? stats?.Goals[1]||0 : '0'} : ${stats?.Goals ? stats?.Goals[2]||0 : '0'}</div>
              <div class="match-info__score-team d-flex flex-column"><div class="match-info__logo"><img class="match-info__logo-image" src="${guestTeamData?.team?.logo ? `/html/cornerkick/assets/images/match/teamlogo/${guestTeamData?.team?.logo}.png` : '/assets/images/logo1.svg'}" alt="" /></div>
              ${guestTeamData?.team?.name || (`
                <button type="button" class="js-join-match default-button" data-id="${data?.id}" data-seo="/${data?.seo}" data-type="${data?.type}" data-price="${data?.price}">
                  <span class="default-button__text">Join</span>
                </button>
              `)}
              </div>
          </div>
          <div class="match-info__lines">
            <div class="match-info__lines-45">
              ${highlights?.filter((item) => Number(item?.minute) <= 45)?.map((item) => `
                <div class="match-info__line" style="left: ${item?.minute * 2}%;">
                  ${getHighlightsOnlyIcon(item.actiontype)}
                </div>
              `).join('')}
            </div>
            <div class="match-info__lines-45">
              ${highlights?.filter((item) => Number(item.minute) > 45)?.map((item) => `
                <div class="match-info__line" style="left: ${(item.minute - 45) * 2}%;">
                  ${getHighlightsOnlyIcon(item.actiontype)}
                </div>
              `).join('')}
            </div>
          </div>
      </div>
  </div>
  ${data?.reward ? `<div class="card__footer"><p>Reward: ${data.reward} $${data.wallet_type}</p></div>` : ""}
`);
